import React from "react";
import "./review.css";
import Form from "react-bootstrap/Form";
import { AiFillStar } from "react-icons/ai";
import { useState } from "react";
import FilterRating from "../filterRating/FilterRating";
import Tags from "./Tags";
import { baseUrl } from "../../context/BaseUrl";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Review = (props) => {
  const [Review, setReview] = useState(null);
  const [rate, setRate] = useState(null);

  const handletagbtn = (e) => {
    setReview();
  };

  const handleReview = async () => {
    try {

      console.log("clicked");
      console.log(props);
      const checkLogin = localStorage.getItem("user");

      if (!checkLogin) {
        toast.error("You are not logged in.");
        return;
      }

      if (!Review) {
        toast.error("Please add comment before submit!!");
        return;
      }
      if (!rate) {
        toast.error("Please select atleast one star to proceed!!");
        return;
      }

      const User = JSON.parse(checkLogin);

      const id = User.user._id;
      const name = User.user.name;
      const token = User.token;

      var ReviewUrl = {
        url: "postreviewoninstitute",
        body: {
          name,
          desc: Review,
          rating: rate * 2,
          ref_id: id,
          institute_id: props.institute_id,
        },
      };

      if (props.url == "course") {
        ReviewUrl = {
          url: "postreviewoncourse",
          body: {
            name,
            desc: Review,
            rating: rate * 2,
            ref_id: id,
            course_id: props.courseid,
          },
        };
      }

      const response = await fetch(
        `${baseUrl}/institute/reviews/${ReviewUrl.url}/${id}`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(ReviewUrl.body),
        }
      );

      const result = await response.json();
      
      if (result.code == 500) {
        toast.success(result.msg);
        return
      }
      // alert("Comment added succesfully!");
      toast.success("Comment added succesfully!");
      props.reload()

      setReview("");
    } catch (error) {
      console.log(error);
    }
  };

  // useEffect(() => {
  //   // RunApi();
  // }, [])

  return (
    <>
      <div className="write-rev" ref={props.data}>
        <h5>Write a Review</h5>
        <p>
          <FilterRating handle={{ rate, setRate }} />
        </p>
        <div>
          <Tags handlebtn={(e) => setReview(e.target.id)} />
        </div>
        <form>
          <Form.Group className="mb-4" controlId="FormTextarea">
            <Form.Control
              as="textarea"
              rows={5}
              placeholder="Review"
              onChange={(e) => setReview(e.target.value)}
              value={Review}
            />
          </Form.Group>
          <button  className="w-mobile-100"  onClick={handleReview} type="button">
            Post
          </button>
        </form>
      </div>
    </>
  );
};

export default Review;
